export const cookieConsent = {
  title: 'Datenschutz',
  description:
    'Diese Webseite verwendet Cookies um Ihre Benutzererfahrung zu verbessern, Ihre Einstellungen zu speichern und unsere Produkte für Sie zu personalisieren.',
  descriptionForSmallScreens:
    'Diese Webseite verwendet Cookies um Ihre Benutzererfahrung zu verbessern.',
  privacyPolicy: 'Datenschutzerklärung',
  acceptAll: 'Alle akzeptieren',
  savePreferences: 'Auswahl speichern',
  functionalCookies: 'Unbedingt erforderliche Cookies',
  analyticsCookies: 'Marketing & Werbung',
}
